import { ContentContainer } from "@/components/ContentContainer";
import PageHead from "@/components/PageHead";
import { MusikSuchenFilter } from "@/components/music/MusikSuchenFilter";
import { MusikSuchenResults } from "@/components/music/MusikSuchenResults";
import { Grid } from "@mui/material";
import { useState } from "react";

export default function BandIndex({ page, restoredFilter }) {
  const [searchConfig, setSearchConfig] = useState(restoredFilter);

  const handleSearchChanged = (filter) => {
    setSearchConfig(filter);
  };

  return (
    <>
      <PageHead page={page} />
      <ContentContainer
        headline={page.headline}
        image={page?.hero_image?.formats?.large?.url}
      >
        <Grid container spacing={{ xs: 1, sm: 3 }}>
          <Grid item xs={12} md={4}>
            <MusikSuchenFilter
              onSearchChanged={handleSearchChanged}
              restoredFilter={restoredFilter}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <MusikSuchenResults searchConfig={searchConfig} />
          </Grid>
        </Grid>
      </ContentContainer>
    </>
  );
}

export const getServerSideProps = async (context) => {
  const pageResponse = await fetch(
    `${
      process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"
    }/page-music-find`,
  );
  const page = await pageResponse.json();

  let restoredFilter = {};

  if (context.query?.filterId) {
    const filterResponse = await fetch(
      `${
        process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"
      }/filter-configs/${context.query?.filterId}`,
    );
    const filter = await filterResponse.json();
    const config = JSON.parse(filter.config);

    restoredFilter = {
      ...config,
    };
  }

  if (context.query?.region) {
    restoredFilter = {
      ...restoredFilter,
      region: { id: context.query?.region },
    };
  }

  if (context.query?.genre) {
    restoredFilter = {
      ...restoredFilter,
      genre: { id: context.query?.genre },
    };
  }

  /*if (context.query?.filterId === "-1") {
    restoredFilter = {
      ...restoredFilter,
      //query: 'Lioness',
      //genre: '3',
      genre: {id: '3', title: 'Alternative'},
      region: { id: 330 },
      //gender: 'with_finta',
      zipcode: { id: 634, zipcode: '51427', label: 'Bergisch Gladbach' },
      radius: '100',
      age_min: 1989,
      age_max: 2021,
      members_min: 4,
      members_max: 6,
      language: 'en',
      _sort: 'sort_this_month',

    }
  }*/

  //console.debug("Restored Filter", restoredFilter);

  return {
    props: {
      page,
      restoredFilter,
    },
  };
};
